// extracted by mini-css-extract-plugin
export var accept = "CookieConsentBanner-module--accept--b7521";
export var banner = "CookieConsentBanner-module--banner--fc8e7";
export var reject = "CookieConsentBanner-module--reject--7d5b5";
export var text = "CookieConsentBanner-module--text--5ef2f";